import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';

@Directive({
  selector: '[notAllowedPermissions]'
})
export class NotAllowedPermissionsDirective {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              public authenticationService: AuthenticationService) {
    this.authenticationService.authenticationEvents$.subscribe(
      () => {
        this.setNotAllowerPermissions(this.notAllowedPermissionsArray);
      }
    );
  }

  @Input()
  set notAllowedPermissions(notAllowedPermission: Array<string>) {
    this.notAllowedPermissionsArray = notAllowedPermission;
    this.setNotAllowerPermissions(notAllowedPermission);
  }

  private notAllowedPermissionsArray = [];

  private setNotAllowerPermissions(notAllowedPermission: Array<string>) {
    const hasPermission = this.authenticationService.userHasOneOfThosePermissions(notAllowedPermission);
    this.viewContainer.clear();
    if (hasPermission === false) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

}
